import { render } from "./CreateTypeExamen.vue?vue&type=template&id=3dd6b007&scoped=true"
import script from "./CreateTypeExamen.vue?vue&type=script&lang=js"
export * from "./CreateTypeExamen.vue?vue&type=script&lang=js"

import "./CreateTypeExamen.vue?vue&type=style&index=0&id=3dd6b007&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd6b007"]])

export default __exports__